export var isApiGatewayUrl = function isApiGatewayUrl(url) {
  return ['/gateway/api', 'https://api-gateway.trellis.coffee/gateway/api', 'https://api-gateway.trello.com/gateway/api'].includes(url);
};